/* src/app/content-editor/content-canvas/content-canvas.component.scss */
:host {
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: transparent;
}
.canvas-head {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 0 10px;
}
.entity-breadcrumbs {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 5px;
}
.entity-breadcrumb-label {
  font-size: 11px;
  font-weight: 500;
  color: var(--text-tertiary);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.entity-breadcrumb-value {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary);
}
.entity-breadcrumb-separator {
  color: var(--text-tertiary);
  font-size: 14px;
  font-weight: 500;
}
.icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 0.5px solid var(--border);
  background: transparent;
  color: var(--text-secondary);
  border-radius: 8px;
  padding: 0;
  font-size: 12px;
  cursor: pointer;
  transition: 0.12s ease;
  flex-shrink: 0;
}
.icon-button:hover {
  border-color: var(--border-hover);
  color: var(--text-primary);
}
.canvas-body {
  min-height: 0;
  flex: 1;
  overflow: auto;
  padding: 0;
  max-width: 800px;
  background: #fff;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.18) transparent;
}
.canvas-body::-webkit-scrollbar {
  width: 8px;
}
.canvas-body::-webkit-scrollbar-track {
  background: transparent;
}
.canvas-body::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.18);
  border-radius: 999px;
  border: 2px solid #fff;
}
.canvas-body::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.28);
}
.empty-state {
  padding: 36px 20px;
  border: 1px dashed var(--border);
  border-radius: 14px;
  text-align: center;
  color: var(--text-tertiary);
  font-size: 13px;
}
::ng-deep .canvas-body app-tree .tree-node {
  margin-top: 0;
}
::ng-deep .canvas-body app-tree .tree-item-container {
  margin-bottom: 2px;
}
::ng-deep .canvas-body app-tree .tree-item {
  border: 0;
  background: transparent;
  border-radius: 8px;
  padding: 10px 12px;
  color: var(--text-primary);
  align-items: flex-start;
}
::ng-deep .canvas-body app-tree .tree-item:hover {
  background: var(--row-hover);
}
::ng-deep .canvas-body app-tree .tree-item.deleted {
  background: #fff4f4;
}
::ng-deep .canvas-body app-tree .tree-item.new-item {
  background: #edf8f1;
  color: #2b6e49;
}
::ng-deep .canvas-body app-tree .tree-item.modified-item {
  background: #fffbe7;
  color: #8a5a00;
  border-left: 3px solid #efc14b;
}
::ng-deep .canvas-body app-tree .tree-item.moved-item {
  box-shadow: inset 3px 0 0 0 var(--accent);
}
::ng-deep .canvas-body app-tree .item-tag {
  min-width: 50px;
  border: 0;
  border-radius: 4px;
  background: var(--bg-secondary);
  color: var(--text-secondary);
  font-size: 11px;
  font-weight: 500;
  text-transform: lowercase;
  text-align: center;
  padding: 1px 8px;
}
::ng-deep .canvas-body app-tree .item-content {
  margin-left: 10px;
  max-width: none;
  flex: 1;
  font-size: 14px;
  line-height: 1.6;
  min-height: 20px;
}
::ng-deep .canvas-body app-tree .children-container {
  margin-left: 8px;
  padding-left: 20px;
  border-left: 1px dashed rgba(0, 0, 0, 0.08);
}
::ng-deep .canvas-body app-tree .tree-actions {
  gap: 6px;
}
::ng-deep .canvas-body app-tree .action-icon {
  opacity: 0;
}
::ng-deep .canvas-body app-tree .tree-item:hover .action-icon {
  opacity: 1;
}
::ng-deep .canvas-body app-tree .add-element-btn {
  width: 100%;
  border: 1px dashed var(--border);
  border-radius: 8px;
  background: transparent;
  color: var(--text-tertiary);
  padding: 10px;
  font-size: 12px;
  text-align: center;
}
::ng-deep .canvas-body app-tree .add-element-btn:hover {
  background: var(--accent-light);
  border-color: rgba(12, 68, 124, 0.25);
  color: var(--accent);
}
/*# sourceMappingURL=content-canvas.component.css.map */
